module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-labor-left-0812b9c866dcdeb3de559b8573c626f4.svg";